/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllProcessingQueryResponse, DocumentsControllerFindAllProcessingPathParams, DocumentsControllerFindAllProcessingQueryParams, DocumentsControllerFindAllProcessing401, DocumentsControllerFindAllProcessing403 } from "../../models/documentsController/DocumentsControllerFindAllProcessing";

function getDocumentsControllerFindAllProcessingUrl(id: DocumentsControllerFindAllProcessingPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing` as const }  
  return res
}

/**
 * @summary Get all processing jobs for a document
 * {@link /api/v1/documents/:id/processing}
 */
export async function documentsControllerFindAllProcessing(id: DocumentsControllerFindAllProcessingPathParams["id"], params: DocumentsControllerFindAllProcessingQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindAllProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessing401 | DocumentsControllerFindAllProcessing403>, unknown>({ method : "GET", url : getDocumentsControllerFindAllProcessingUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}